var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    fillRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 12.9C1.2 12.9 0 14 0 15.4S1.2 18 2.6 18c1.4 0 2.6-1.2 2.6-2.6-.1-1.4-1.2-2.5-2.6-2.5zm6.4 0c-1.4 0-2.6 1.2-2.6 2.6C6.4 16.8 7.6 18 9 18c1.4 0 2.6-1.2 2.6-2.6 0-1.4-1.2-2.5-2.6-2.5zm6.4 0c-1.4 0-2.6 1.2-2.6 2.6S14 18 15.4 18c1.4 0 2.6-1.2 2.6-2.6 0-1.4-1.2-2.5-2.6-2.5zM2.6 6.4C1.2 6.4 0 7.6 0 9s1.2 2.6 2.6 2.6S5.1 10.4 5.1 9c0-1.4-1.1-2.6-2.5-2.6zm6.4 0C7.6 6.4 6.4 7.6 6.4 9s1.2 2.6 2.6 2.6c1.4 0 2.6-1.2 2.6-2.6 0-1.4-1.2-2.6-2.6-2.6zm6.4 0c-1.4 0-2.6 1.2-2.6 2.6 0 1.4 1.2 2.6 2.6 2.6 1.4 0 2.6-1.2 2.6-2.6 0-1.4-1.2-2.6-2.6-2.6zM2.6 0C1.2 0 0 1.2 0 2.6s1.2 2.6 2.6 2.6C4 5.1 5.1 4 5.1 2.6 5.1 1.2 4 0 2.6 0zM9 0C7.6 0 6.4 1.2 6.4 2.6 6.4 4 7.6 5.1 9 5.1c1.4 0 2.6-1.2 2.6-2.6C11.6 1.2 10.4 0 9 0zm6.4 5.1C16.8 5.1 18 4 18 2.6S16.9 0 15.4 0c-1.4 0-2.6 1.2-2.6 2.6.1 1.4 1.2 2.5 2.6 2.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.ad6f5e61.svg";
export { ForwardRef as ReactComponent };